import { useSelector } from "react-redux";
import { Button, Stack } from "@mui/material";
import styled from "styled-components";
import React, { Fragment, useEffect, useState } from "react";
import {
  Business,
  AccountCircle,
  Sell,
  CorporateFare,
} from "@mui/icons-material";

import Form from "./profile details components/Form";
import { colors } from "../css components/Style";
import BrandDetails from "../brand components/BrandDetails";
import CompanyDetails from "../company components/CompanyDetails";
import AgencyDetails from "../agency components/Agency";

const TabButton = styled(Button)`
  text-transform: none;
  padding: 10px 25px;
  font-weight: 500;
  letter-spacing: 0.18px;
  font-size: 15px;
`;

export default function Profile() {
  const { userData, role, agencyID } = useSelector(
    (state) => state.memberDetails
  );

  const [formData, setFormData] = useState(userData);

  const [selectedTab, setSelectedTab] = useState("User Profile");

  const [tabItems, setTabItems] = useState([
    {
      label: "User Profile",
      icon: <AccountCircle style={{ height: "32px", width: "32px" }} />,
    },
  ]);

  useEffect(() => {
    if (role === "AGENCY") {
      setTabItems((prev) => [
        ...prev,
        {
          label: "Agency",
          icon: <CorporateFare style={{ height: "32px", width: "32px" }} />,
        },
        {
          label: "Company",
          icon: <Business style={{ height: "32px", width: "32px" }} />,
        },
      ]);
    }

    if (role === "NORMAL_USER") {
      setTabItems((prev) => [
        ...prev,
        {
          label: "Brand",
          icon: <Sell style={{ height: "32px", width: "32px" }} />,
        },
        {
          ...(!agencyID && {
            label: "Company",
            icon: <Business style={{ height: "32px", width: "32px" }} />,
          }),
        },
      ]);
    }
  }, [role, agencyID]);
  return (
    <Fragment>
      <Stack direction="row" spacing={2} style={{ marginBottom: "20px" }}>
        {tabItems.map((tab) => {
          const isSelected = selectedTab === tab.label;

          return (
            <TabButton
              key={tab.label}
              onClick={() => setSelectedTab(tab.label)}
              startIcon={tab.icon}
              sx={{
                fontSize: "16px",
                fontWeight: "500",
                color: colors.purple,
                backgroundColor: isSelected ? "#ff6d1d12" : undefined,
                padding: "8.5px 20px",
                borderRadius: "16px",
                "&:hover": {
                  backgroundColor: isSelected ? "#ff6d1d12" : "#e988df36",
                },
                marginRight: "15px",
              }}
            >
              {tab.label}
            </TabButton>
          );
        })}
      </Stack>

      {selectedTab === "User Profile" && (
        <Form formData={formData} setFormData={setFormData} />
      )}

      {selectedTab === "Brand" && <BrandDetails />}

      {selectedTab === "Agency" && <AgencyDetails />}

      {selectedTab === "Company" && <CompanyDetails withCompany={true} />}
    </Fragment>
  );
}
